<template>
  <div class="echarts" id="housingRightOne"></div>
</template>
<script>
import { defineComponent, reactive, toRefs, onMounted } from "vue";
import { houseType } from "@/api/dataAnalysis/housingAnalysis.js";

import * as echarts from "echarts";
export default defineComponent({
  name: "",
  components: {},
  props: {},
  setup(props) {
    const data = reactive({
      regionId: 0,
      obj: [],
    });
    const refData = toRefs(data);
    // 房屋类别
    const houseTypelist = async () => {
      const res = await houseType(data.regionId);
      res.data.forEach((v) => {
        data.obj.push({ value: v.value, name: v.name });
      });
      console.log(res, "------------------");
    };
    onMounted(async () => {
      await houseTypelist();
      data.regionId = JSON.parse(localStorage.getItem("regionId"));

      const myChart = echarts.init(document.getElementById("housingRightOne"));
      myChart &&
        myChart.setOption({
          color: ["#F56463", "#00C6FF", "#F09615", "#0079E6"],
          legend: {
            itemHeight: 14,
            itemWidth: 14,
            icon: "rect",
            orient: "vertical",
            top: "center",
            right: "5%",
            textStyle: {
              align: "left",
              color: "#",
              verticalAlign: "middle",
              rich: {
                name: {
                  width: 80,
                  fontSize: 16,
                },
                value: {
                  width: 20,
                  align: "right",
                  fontFamily: "Medium",
                  fontSize: 16,
                },
                rate: { width: 10, align: "right", fontSize: 16 },
              },
            },
            formatter: (name) => {
              if (data.obj.length) {
                const item = data.obj.filter((item) => item.name === name)[0];
                return `{name|${name}}`;
              }
            },
          },
          tooltip: {
            trigger: "item",
            formatter: "{d}%",
          },
          series: [
            {
              name: "",
              type: "pie",
              radius: ["40%", "70%"],
              center: ["35%", "50%"],
              roseType: "radius",
              label: {
                formatter: "{d}%",
              },
              labelLine: {
                length: 20,
                length2: 40,
              },
              data: data.obj,
            },
          ],
        });
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    });

    return {
      ...refData,
      houseTypelist,
    };
  },
});
</script>
<style lang="scss" scoped>
#housingRightOne {
  width: 100%;
  height: 90%;
}
</style>
